<!--分析组件-->
<template>
	<div class="analysisModuleBody">
		<div class="analysis_title" :style="titleFontColor">
			<p>用</p>
			<p>{{type}}</p>
			<p>分</p>
			<p>析</p>
		</div>
		<div class="analysis_details">
			<div class="analysis_details_div">
				<div class="analysis_details_content">
					<span class="analysis_details_content_span_left">去年用{{type}}</span>
					<span class="analysis_details_content_span_rigth">{{lasYear}}{{unit}}</span>
				</div>
				<div class="analysis_details_content">
					<span class="analysis_details_content_span_left">同比</span>
					<div>
						<img :src="getUpAndDown(getYoy(lasYear,year))" />
						<span>{{getYoy(lasYear,year)}}%</span>
					</div>
				</div>
			</div>
			<div class="analysis_details_div">
				<div class="analysis_details_content">
					<span class="analysis_details_content_span_left">上月用{{type}}</span>
					<span class="analysis_details_content_span_rigth">{{lasMonth}}{{unit}}</span>
				</div>
				<div class="analysis_details_content">
					<span class="analysis_details_content_span_left">同比</span>
					<div>
						<img :src="getUpAndDown(getYoy(lasMonth,month))" />
						<span>{{getYoy(lasMonth,month)}}%</span>
					</div>
				</div>
			</div>
		</div>
		<!--趋势-->
		<div class="qushiBody">
			<vchart ref="qsVchart"></vchart>
		</div>
		<!--占比-->
		<div class="zhanbiBody">
			<vchart ref="zbVchart"></vchart>
		</div>
	</div>
</template>
<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			vchart,
		},
		props: {
			titleColor: {
				type: String,
			},
			xData: {
				type: Array,
			},
			type: {
				type: String,
			},
			unit: {
				type: String,
			},

		},
		data() {
			return {
				lasYear: 0,
				year: 0,
				lasMonth: 0,
				month: 0,
				qsOption: {
					title: {
						text: '',
						left: 'center',
						top: "20px",
						textStyle: {
							color: "#ffffff",
						}
					},
					tooltip: {
						trigger: 'item',
						formatter: '{b} : {c}',
						show: true,
					},
					legend: {
						bottom: '0',
						textStyle: {
							color: "#ffffff",
						},
						data: []
					},
					xAxis: {
						type: 'category',
						axisTick: {
							show: true
						},
						axisLine: {
							show: true
						},
						axisLabel: {
							textStyle: {
								color: '#ffffff'
							}
						},
						data: []
					},
					yAxis: {
						name: '单位:',
						nameTextStyle: {
							color: "#ffffff",
							fontSize: 14,
						},
						type: 'value',
						splitLine: {
							show: true,
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: 'black'
							}
						},
						axisTick: {
							show: false,
						},
						axisLine: {
							show: true,
						},
					},
					grid: [{
						bottom: '10%',
						height: 150,
						left: '2%',
						rigth: 0,
						containLabel: true,
					}],
					series: [{
						data: [],
						type: 'bar',
						barWidth: 100,
						itemStyle: {
							normal: {
								color: function(params) {
									var colorList = ['#00BFEF', '#00A843', '#FF9A16'];
									return colorList[params.dataIndex]
								}
							}
						},
						label: {
							show: false,
							position: 'inside',
							color: 'black'
						},
					}]

				},
				zbOption: {
					tooltip: {
						trigger: 'item',
						formatter: '{b} : {c}',
						show: true,
					},
					legend: {
						orient: 'vertical',
						icon: "circle",
						left: 'left',
						top: 'center',
						textStyle: {
							color: 'white',
						},
						show: false,
						itemGap: 40,
						padding: [0, 0, 0, 10],
						data: []
					},
					color: ['#407fff', '#f29961', '#e15d68'],
					series: [{
						type: 'pie',
						radius: ['40%', '60%'],
						center: ['30%', '50%'],
						label: {
							normal: {
								show: true,
								position: 'inner',
								textStyle: {
									fontWeight: 100,
									fontSize: 12
								},
								formatter: '{d}%'

							}
						},
						data: [],
						emphasis: {
							itemStyle: {
								shadowBlur: 20,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]

				}
			}
		},
		created() {},
		mounted() {
			this.$refs.qsVchart.setData(this.qsOption)
			this.$refs.zbVchart.setData(this.zbOption)
			this.initData()
		},
		destroyed() {},
		computed: {
			titleFontColor() {
				return {
					"color": this.titleColor
				}
			},
			getImage() {
				return img => {
					return resourcesStore.getters.getResourcesByName('energyEfficiencySystem/overview/' + img)
				}
			},
			getUpAndDown() {
				return value => {
					let img = ""
					value >= 0 ? img = "2.png" : img = "2y.png"
					return resourcesStore.getters.getResourcesByName('energyEfficiencySystem/overview/arrow/' + img)
				}
			},
			getYoy() {
				return(lasData, data) => {
					if(!isempty(lasData) && !isempty(data)) {
						if(lasData == 0) {
							return 0
						}
						return(((data - lasData) / lasData) * 100).toFixed(2)
					}
				}
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
		},
		watch: {
			xData(nv, ov) {
				this.initData()
			},
		},
		methods: {
			initData() {
				//获取数据
				if(isempty(this.nowUnit.id)) {
					return
				}
				let appType = 0
				switch(this.type) {
					case "电":
						appType = 36
						break;
					case "水":
						appType = 237
						break;
					case "气":
						appType = 361
						break;
				}
				let xData = []
				for(let i = 0; i < 24; i++) {
					if(i > 0) {
						xData.push(i + ':00')
					} else {
						xData.push("0" + i + ':00')
					}
				}
				this.qsOption.title.text = "用" + this.type + "分析"
				this.qsOption.xAxis.data = xData
				this.qsOption.yAxis.name = "单位:" + this.unit
				this.qsOption.legend.data = this.xData
				this.zbOption.legend.data = this.xData
				let seriesData = []
				let pieData = []
				this.$api.areausePower.getHomeAnalysis(this.nowUnit.id, appType, respon => {
					if(!isempty(respon)) {
						this.lasYear = respon.lasYear
						this.year = respon.year
						this.lasMonth = respon.lasMonth
						this.month = respon.month
						this.xData.forEach(item => {
							let obj = {
								name: '',
								type: 'bar',
								stack: '值',
								barWidth: 20,
								label: {
									show: false,
								},
								data: []
							}
							obj.name = item
							obj.data = respon.barData[item]
							seriesData.push(obj)
							pieData.push({
								value: respon.pie[item],
								name: item
							})
						})
						this.qsOption.series = seriesData
						this.$refs.qsVchart.setData(this.qsOption)
						this.zbOption.series[0].data = pieData
						this.$refs.zbVchart.setData(this.zbOption)

					}
				})
			}
		}
	}
</script>

<style scoped>
	.analysisModuleBody {
		width: 100%;
		height: 32%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	    border: .01rem solid #2e43b0;
	    background-color: #010e5e;
	    border-radius: .1rem;
	}
	
	.analysis_title {
		padding-left: .2rem;
	}
	
	.analysis_title p {
		font-size: .2rem;
		line-height: .3rem;
		font-weight: 600;
	}
	
	.analysis_details {
		width: 18%;
		height: 99%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	
	.analysis_details_div {
		width: 100%;
		height: 48%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	
	.analysis_details_content {
		width: 100%;
		height: 40%;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
	
	.analysis_details_content span {
		font-size: .2rem;
	}
	
	.analysis_details_content div {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 50%;
	}
	
	.analysis_details_content_span_left {
		width: 50%;
		text-align: left;
		padding-left: .1rem;
	}
	
	.analysis_details_content_span_rigth {
		width: 50%;
		text-align: right;
		padding-right: .1rem;
	}
	
	.qushiBody {
		width: 50%;
		height: 100%;
	}
	
	.zhanbiBody {
		width: 20%;
		height: 100%;
	}
	
	.analysisModuleBody .default-chart {
		height: 100%;
	}
</style>
<style>
	.analysisModuleBody .el-divider--horizontal {
		margin: 0;
	}
</style>